export default __webpack_public_path__ + "static/media/chicago.4f379ade.png";